import {gql} from 'apollo-angular';
import {ProfessionPreviewFragment} from "./fragments/ProfessionPreview";
import {StoryFragment} from "./fragments/Story";

export const GET_PROFESSION_BY_ID = gql`
  query GetProfessionById($id: ID!) {
    job(bicid: $id) {
      ...professionPreviewFields,
      videoUrl
      pdfUrl
      image {
        medium {
          url
          width
        }
      }
      searchTags
      description
      scholasticDuration {
        durationName
        position
      }
      schoolSubjectMappings {
        jobSchoolSubject {
          subjectName
        }
      }
      interestFields {
        id
      }
      showSchoolSubjects
      operationsAndTasks
      jobWorkFields {
        name
        description
        bicID
      }
      jobSectors {
        name
        bicID
        description
        id
      }
      jobLinkMappings {
        id
        jobLinkMappingCategory {
          id
          name
        }
        jobLinkMappingType {
          id
          name
        }
        jobLink {
          titleFrontend
          url
        }
      }
      bicAusbildungBerufschule,
      expertTerms {
        termName
        description
      },
      bicMoeglichkeiten
      bicAlternativen
      jobMarketDistricts {
        districts {
          districtID
          trainingCompanies {
            id
          }
          jobMarketEntries {
            id
          }
        }
      }
      jobRedirects {
        bicID
        redirectType
        jobName
      }
      insights {
        ...storyFields
      }
      jobSalary {
        entryValue
        amsUrl
        lehrlingseinkommenUrl
        entries {
          salaryType
          salaryFrom
          salaryTo
        }
      }
      jobSchools {
        school {
          name
          url
          address {
            street
            number
            addressCity {
              name
            }
          }
          communication {
            entries {
              id
              entryValue
              communicationType {
                shortName
              }
            }
          }
        }
      }
    }
  }
  ${StoryFragment}
  ${ProfessionPreviewFragment}
`;
